import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=utf-8',
        'Authorization': ConstantsService.AUTH_TOKEN
    })
};


@Injectable()
export class ExamService {

    constructor(private http: HttpClient) { }

    getFirstQuestionAdaptive(rootUrl: string, usercode: string, student_id: number, exam_id: number, dlselect_id: number): Observable<any> {
        if(dlselect_id != 0)
        {
            return this.http.post<any>(rootUrl + 'exam/adaptive/exam', { usercode: usercode, student_id: student_id, exam_id: exam_id, dl_level:dlselect_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
        }
        else
        {
            return this.http.post<any>(rootUrl + 'exam/adaptive/exam', { usercode: usercode, student_id: student_id, exam_id: exam_id}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
        }
    }
    getFirstQuestion(rootUrl: string, usercode: string, student_id: number, exam_id: number, shuffle_ans: number, shuffle_ques: number, auto: number, theory2: number, phycho: number): Observable<any> {
        //console.log('auto '+ auto);
        if(auto == 0)
        {
            if(theory2 == 1)
            {
                return this.http.post<any>(rootUrl + 'exam/theorySecond/exam', { usercode: usercode, student_id: student_id, exam_id: exam_id, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); 
            } 
            else if(phycho == 1)
            {
                return this.http.post<any>(rootUrl + 'exam/psyc/exam', { usercode: usercode, student_id: student_id, exam_id: exam_id, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); 
            } 
            else
            {
                return this.http.post<any>(rootUrl + 'question/exams', { usercode: usercode, student_id: student_id, exam_id: exam_id, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                    .pipe(map(user => {
                        return user;
                    }));                 
            }                       
        }
        if(auto == 1)
        {
            if(theory2 == 1)
            {
/*                return this.http.post<any>(rootUrl + 'exam/theorySecond/exam', { usercode: usercode, student_id: student_id, exam_id: exam_id, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); */
            } 
            else
            {
                return this.http.post<any>(rootUrl + 'exam/getRandomizeExam', { usercode: usercode, student_id: student_id, exam_id: exam_id, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); 
            }                       
        }
    }
    

    getQuestionByIndexAdaptive(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/questionByIndex', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    getQuestionByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, deficulty_lebel: number, timer_questindex: number, time_taken: number, shuffle_ans: number, shuffle_ques: number, auto: number, theory2: number, phycho: number): Observable<any> {
        //console.log('autoNext '+ auto);
        if(auto == 0)
        {
            if(theory2 == 1)
            {
                return this.http.post<any>(rootUrl + 'exam/theorySecond/questionByIndex', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, timer_questindex: timer_questindex, time_taken: time_taken, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
            } 
            else if(phycho == 1)
            {
                return this.http.post<any>(rootUrl + 'exam/psyc/questionByIndex', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, timer_questindex: timer_questindex, time_taken: time_taken, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                .pipe(map(user => {
                    return user;
                })); 
            }
            else
            {
                return this.http.post<any>(rootUrl + 'question/questionByNo', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, deficulty_lebel: deficulty_lebel, timer_questindex: timer_questindex, time_taken: time_taken, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                .pipe(map(user => {
                    return user;
                })); 
            }         
        }
        if(auto == 1){
            if(theory2 == 1)
            {
/*                return this.http.post<any>(rootUrl + 'exam/theorySecond/questionByIndex', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, timer_questindex: timer_questindex, time_taken: time_taken, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));*/ // this function will be rewrite here
            }
            else
            {
                return this.http.post<any>(rootUrl + 'exam/getQuestionByIndexInAutoSet', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, deficulty_lebel: deficulty_lebel, timer_questindex: timer_questindex, time_taken: time_taken, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
                    .pipe(map(user => {
                        return user;
                    })); 
            }                     
        }        
    }
    setQuestionByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, answer_id: number, time_taken: number, lock_status: number, question_id: number, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/submitByQuesIndexWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, answer_id: answer_id, time_taken: time_taken, lock_status: lock_status,question_id: question_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else
        {
            return this.http.post<any>(rootUrl + 'question/submitByIndex', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, answer_id: answer_id, time_taken: time_taken, lock_status: lock_status, question_id: question_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }         
    }
    setQuestionByIndexPsycho(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, answer_id: string, time_taken: number, lock_status: number, question_id: number, theory2: number, phycho: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/psyc/submitByQuesIndexWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, answer_id: answer_id, time_taken: time_taken, lock_status: lock_status,question_id: question_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }
    setQuestionByIndexAdaptive(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, answer_id: number, time_taken: number, question_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/submitByQuesIndex', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, answer_id: answer_id, time_taken: time_taken, question_id: question_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }    
    setQuestionAnswer(rootUrl: string, usercode: string, exam_id: number, students: any, type: number, total_time_taken: any, mock_exam: number, total_question: number, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/examSubmitWeb', { usercode: usercode, exam_id: exam_id, students: students, type: type, total_time_taken: total_time_taken }, httpOptions)
                .pipe(map(user => {
                    return user;
                })); 
        } 
        else if(phycho == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/psyc/examSubmitWeb', { usercode: usercode, exam_id: exam_id, students: students, type: type, total_time_taken: total_time_taken }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else
        {
            return this.http.post<any>(rootUrl + 'question/answer/submited', { usercode: usercode, exam_id: exam_id, students: students, type: type, total_time_taken: total_time_taken, mock_exam: mock_exam, total_question : total_question  }, httpOptions)
                .pipe(map(user => {
                    return user;
                })); 
        }        
    }
    setQuestionAnswerAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number, total_time_taken: any): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/examSubmit', { usercode: usercode, exam_id: exam_id, student_id:student_id, total_time_taken: total_time_taken }, httpOptions)
            .pipe(map(user => {
                return user;
            }));       
    }
    setExamPauseResume(rootUrl: string, usercode: string, student_id: number, exam_id: number, status: string, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/log', { usercode: usercode, exam_id: exam_id, student_id: student_id, status: status }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else if(phycho == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/psyc/log', { usercode: usercode, exam_id: exam_id, student_id: student_id, status: status }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else
        {
            return this.http.post<any>(rootUrl + 'student/log', { usercode: usercode, exam_id: exam_id, student_id: student_id, status: status }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }         

    }

    getVivaFirstQuestion(rootUrl: string, usercode: string, student_id: number, exam_id: number, req_by: string, shuffle_ans: number, shuffle_ques: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'question/viva', { usercode: usercode, student_id: student_id, exam_id: exam_id, req_by: req_by, shuffle_ans: shuffle_ans, shuffle_ques: shuffle_ques }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    getVivaQuestionByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, answer_id: number, req_by: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'question/vivaquestionByNo', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, req_by: req_by }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    setVivaQuestionByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, req_by: string, answer_type: string, file: any, question_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'question/viva/saveweb', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, req_by: req_by, answer_type: answer_type, file: file, question_id: question_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }


    saveExamPic(rootUrl: string, usercode: string, student_id: number, exam_id: number, req_by: string, file: any, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/saveRandomImageWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, req_by: req_by, file: file }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else if(phycho == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/psyc/saveRandomImageWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, req_by: req_by, file: file }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }       
        else
        {
            return this.http.post<any>(rootUrl + 'exam/student/image', { usercode: usercode, exam_id: exam_id, student_id: student_id, req_by: req_by, file: file }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }         
    }
    saveExamPicAdaptive(rootUrl: string, usercode: string, student_id: number, exam_id: number, req_by: string, file: any): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/saveRandomImageWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, req_by: req_by, file: file }, httpOptions)
            .pipe(map(user => {
                return user;
            }));         
        
    }
    getStudentToken(rootUrl: string, usercode: string, student_id: number, exam_id: number, req_by: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/student/gettoken', { usercode: usercode, exam_id: exam_id, student_id: student_id, req_by: req_by }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    setVivaSubmit(rootUrl: string, usercode: string, student_id: number, exam_id: number, type: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'question/viva/submit', { usercode: usercode, exam_id: exam_id, student_id: student_id, type: type }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    getPracticalInfo(rootUrl: string, usercode: string, student_id: number, exam_id: number, practical_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/getpractical', { usercode: usercode, student_id: student_id, exam_id: exam_id, practical_id: practical_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    checkPractical(rootUrl: string, usercode: string, student_id: number, exam_id: number, practical_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/getpracticalStatus', { usercode: usercode, student_id: student_id, exam_id: exam_id, practical_id: practical_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    getDescriptiveQuestion(rootUrl: string, usercode: string, student_id: number, exam_id: number, shuffle_ques: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getOnlineDesciptiveExams', { usercode: usercode, student_id: student_id, exam_id: exam_id, shuffle_ques: shuffle_ques }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    getDescriptiveQuestionByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, shuffle_ques: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getDesQuesByNo', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, shuffle_ques: shuffle_ques }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    setDescriptiveQuestionByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, qb_index: number, answer: string, question_id: number, attach: number, file, attach_type: number,time_taken:number,time:number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/saveDescriptiveAnswerText', { usercode: usercode, exam_id: exam_id, student_id: student_id, qb_index: qb_index, answer: answer, question_id: question_id, attach: attach, file: file, attach_type: attach_type, time_taken:time_taken, time:time }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    endDescriptive(rootUrl: string, usercode: string, exam_id: number, student_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/endDescriptiveExam', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }

    saveAttachment(rootUrl: string, usercode: string, student_id: number, exam_id: number, question_id: number, attachment, attach_type: number, file_name: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/saveDescriptiveAnswerAttachmentWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, question_id: question_id, attachment: attachment, attach_type: attach_type, file_name: file_name }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    savecanvasByIndex(rootUrl: string, usercode: string, student_id: number, exam_id: number, qb_index: number, file: string, question_id: number,time_taken:number,timeRemain:number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/saveDescriptiveAnswerImageWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, qb_index: qb_index, file: file, question_id: question_id,time_taken:time_taken, time:timeRemain }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    setBGlog(rootUrl: string, usercode: string, student_id: number, exam_id: number, user_id: number, sub_user_id: number, status: string, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/log', { usercode: usercode, student_id: student_id, exam_id: exam_id, user_id: user_id, sub_user_id:sub_user_id, status:status }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }
        else if(phycho == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/psyc/log', { usercode: usercode, student_id: student_id, exam_id: exam_id, user_id: user_id, sub_user_id:sub_user_id, status:status }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else
        {
            return this.http.post<any>(rootUrl + 'exam/m/student/log', { usercode: usercode, student_id: student_id, exam_id: exam_id, user_id: user_id, sub_user_id:sub_user_id, status:status }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }         
    }
    setBGlogAdaptive(rootUrl: string, usercode: string, student_id: number, exam_id: number, user_id: number, sub_user_id: number, status: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/log', { usercode: usercode, student_id: student_id, exam_id: exam_id, user_id: user_id, sub_user_id:sub_user_id, status:status }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }    
    multiface(rootUrl: string, usercode: string, exam_id: number, student_id: number, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/multifaceWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else if(phycho == 1)
        {
           return this.http.post<any>(rootUrl + 'exam/psyc/multifaceWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }
        else
        {
            return this.http.post<any>(rootUrl + 'exam/multifaceweb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }         
    }     
    multiobject(rootUrl: string, usercode: string, exam_id: number, student_id: number, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/multiobjectWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else if(phycho == 1)
        {
           return this.http.post<any>(rootUrl + 'exam/psyc/multiobjectWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }        
        else
        {
            return this.http.post<any>(rootUrl + 'exam/multiobjectweb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }        
    } 
    profilematch(rootUrl: string, usercode: string, exam_id: number, student_id: number, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/facecompareWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else if(phycho == 1)
        {
           return this.http.post<any>(rootUrl + 'exam/psyc/facecompareWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }        
        else
        {
            return this.http.post<any>(rootUrl + 'exam/facecompareweb', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }        
    }
    multifaceAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/adaptive/faceDetection', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }    
    multifaceAlertAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/adaptive/faceDetection', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }      
    profilematchAlertAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/adaptive/faceMatching', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }  
    multiobjectAlertAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/adaptive/objectDetection', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }    
    multifaceAlertTheory(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/multiface', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }      
    profilematchAlertTheory(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/facecompare', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }  
    multiobjectAlertTheory(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/multiobject', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }   
    multifaceAlertTheory2(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/theorySecond/multiface', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }      
    profilematchAlertTheory2(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/theorySecond/facecompare', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }  
    multiobjectAlertTheory2(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/theorySecond/multiobject', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }        
    multifaceAlertPsycho(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/psyc/multiface', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }      
    profilematchAlertPsycho(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/psyc/facecompare', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }  
    multiobjectAlertPsycho(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,): Observable<any> {
       return this.http.post<any>(rootUrl + 'exam/psyc/multiobject', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }        
    multiobjectAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/objectDetection', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }     
    profilematchAdaptive(rootUrl: string, usercode: string, exam_id: number, student_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/adaptive/faceMatching', { usercode: usercode, exam_id: exam_id, student_id: student_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }    
    examFreezeStatus(rootUrl: string,  student_id: number,usercode: string, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/checkFreezeStatus', {student_id: student_id, usercode: usercode, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }   
    getGLanguages(rootUrl: string,  student_id: number,usercode: string, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getVTTLanguages', {student_id: student_id, usercode: usercode, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    getSecLanguages(rootUrl: string,  exam_type: number,usercode: string, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/getSecondaryLanguage', {exam_type: exam_type, usercode: usercode, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    setResetOption(rootUrl: string,  usercode: string, student_id: number, exam_id: number, question_id: number, theory2: number, phycho: number): Observable<any> {
        if(theory2 == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theorySecond/clearAnsweredOption', {usercode: usercode, student_id: student_id, exam_id: exam_id, question_id: question_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }
        else if(phycho == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/psyc/clearAnsweredOption', {usercode: usercode, student_id: student_id, exam_id: exam_id, question_id: question_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        } 
        else
        {
            return this.http.post<any>(rootUrl + 'exam/clearAnsweredOption', {usercode: usercode, student_id: student_id, exam_id: exam_id, question_id: question_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));
        }         
    } 
    setExamScreen(rootUrl: string,  student_id: number,usercode: string, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/setOnExamScreen', {student_id: student_id, usercode: usercode, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getTypingQuestion(rootUrl: string, usercode: string, student_id: number, exam_id: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/typing/fetchExam', { usercode: usercode, student_id: student_id, exam_id: exam_id }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    } 
    submitTypingExam(rootUrl: string, usercode: string, student_id: number, exam_id: number, answer: string): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/typing/submitExam', { usercode: usercode, student_id: student_id, exam_id: exam_id, answer: answer }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }  
    getFirstQuestionTheory3(rootUrl: string, usercode: string, student_id: number, exam_id: number, auto: number, second_exam: number): Observable<any> {
        if(auto == 0)
        {
            return this.http.post<any>(rootUrl + 'exam/theory3/exam', { usercode: usercode, student_id: student_id, exam_id: exam_id, second_exam: second_exam }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));                                       
        }
        if(auto == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theory3/examAuto', { usercode: usercode, student_id: student_id, exam_id: exam_id }, httpOptions)
                .pipe(map(user => {
                    return user;
                }));                      
        }
    } 
    getQuestionByIndexTheory3(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, pre_index: number, pre_time_taken: number, auto: number, second_exam: number): Observable<any> {
        if(auto == 1)
        {
            return this.http.post<any>(rootUrl + 'exam/theory3/questionByIndexAuto', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, pre_index: pre_index, pre_time_taken: pre_time_taken}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
        }
        else
        {
            return this.http.post<any>(rootUrl + 'exam/theory3/questionByIndex', { usercode: usercode, student_id: student_id, exam_id: exam_id, index: index, pre_index: pre_index, pre_time_taken: pre_time_taken, second_exam: second_exam}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
        }
    } 
    saveExamPictheory3(rootUrl: string, usercode: string, student_id: number, exam_id: number, req_by: string, file: any, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/saveRandomImageWeb', { usercode: usercode, exam_id: exam_id, student_id: student_id, req_by: req_by, file: file, second_exam:second_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));         
        
    }   
    multifaceAlertTheory3(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/faceDetection', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto, second_exam: second_exam }, httpOptions)
             .pipe(map(user => {
                 return user;
             }));        
     }      
     profilematchAlertTheory3(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string,second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/faceMatching', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto, second_exam: second_exam }, httpOptions)
             .pipe(map(user => {
                 return user;
             }));        
     }  
     multiobjectAlertTheory3(rootUrl: string, usercode: string, exam_id: number, student_id: number, randomphoto: string, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/objectDetection', { usercode: usercode, exam_id: exam_id, student_id: student_id, randomphoto: randomphoto, second_exam: second_exam }, httpOptions)
             .pipe(map(user => {
                 return user;
             }));        
     }        
     setBGlogTheory3(rootUrl: string, usercode: string, student_id: number, exam_id: number, user_id: number, sub_user_id: number, status: string, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/log', { usercode: usercode, student_id: student_id, exam_id: exam_id, user_id: user_id, sub_user_id:sub_user_id, status:status, second_exam: second_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }    
    setResetOptionTheory3(rootUrl: string,  usercode: string, student_id: number, exam_id: number, question_id: number, index: number, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/clearAnsweredOption', {usercode: usercode, student_id: student_id, exam_id: exam_id, question_id: question_id, index: index, second_exam: second_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));   
    }  
    setQuestionAnswerTheory3(rootUrl: string, usercode: string, exam_id: number, student_id: number, total_time_taken: any, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/examSubmit', { usercode: usercode, exam_id: exam_id, student_id:student_id, total_time_taken: total_time_taken, second_exam: second_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));       
    }    
    setQuestionByIndexTheory3(rootUrl: string, usercode: string, student_id: number, exam_id: number, index: number, answer_id: string, question_id: number, mcq: number, sequence_index: string, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/submitByQuesIndex', { usercode: usercode, exam_id: exam_id, student_id: student_id, index: index, answer_id: answer_id, question_id: question_id, mcq: mcq, sequence_index: sequence_index, second_exam:second_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        
    }  
    setExamLogAutoSubmit(rootUrl: string,  student_id: number,usercode: string, exam_id: number, reason: string, exam_type: number, id_autosubmit_type : number ): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/autosubmit/log', {student_id: student_id, usercode: usercode, exam_id: exam_id, reason: reason, exam_type: exam_type, id_autosubmit_type : id_autosubmit_type }, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }
    setExamPauseResumeTheory3(rootUrl: string, usercode: string, student_id: number, exam_id: number, user_id: number, sub_user_id: number, status: string, second_exam: number): Observable<any> {
        return this.http.post<any>(rootUrl + 'exam/theory3/log', { usercode: usercode, exam_id: exam_id, student_id: student_id, user_id: user_id, sub_user_id:sub_user_id, status: status, second_exam: second_exam }, httpOptions)
            .pipe(map(user => {
                return user;
            }));        

    }      
    logintoT4(rootUrl: string, exam_id: number, student_id: number, os: string, build: string, notId: string):Observable<any> {      
        return this.http.post<any>(rootUrl+'exam/theory4/initialize', {exam_id:exam_id, student_id: student_id, os:'web', notId:'', build:''}, httpOptions)
            .pipe(map(user => {
                return user;
            }));
    }                                                             
}